import { render } from "./user-details-form.vue?vue&type=template&id=916595c2&ts=true"
import script from "./user-details-form.ts?vue&type=script&lang=ts&external"
export * from "./user-details-form.ts?vue&type=script&lang=ts&external"

import "./user-details-form.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__